import Api from './Api';

export default {
  fetch: (params) => Api.get('/v1/payments/userData', { params }),
};
